import { toDate as o } from "./toDate.js";
function r(e, n) {
  const t = o(e);
  return t.setMinutes(n), t;
}
export {
  r as default,
  r as setMinutes
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/date-fns@3.6.0/~/date-fns/setMinutes.js
// module id = 1398
// module chunks = 41